var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Game"},[_c('iframe',{staticClass:"iframe",attrs:{"src":"/panorama/temporary-exhibition/05_Morandi/scene/index.html#/?m=1397","frameborder":"0"}})])
}]

export { render, staticRenderFns }